import Cookies from 'js-cookie';

function getUtms() {
    const utmParams = Cookies.get('utm_params');

    return utmParams ? JSON.parse(utmParams) : '';
}

function camelToUnderscore(key) {
    return key.replace(/([A-Z])/g, '_$1').toLowerCase();
}

function formatUtmsToUnderscore(utms) {
    const utmObject = {};

    Object.entries(utms).forEach(([key, value]) => {
        Object.assign(
            utmObject,
            { [camelToUnderscore(key)]: value },
        );
    });

    return utmObject;
}

export function getFormatedUtms() {
    return formatUtmsToUnderscore(getUtms());
}
